export default __webpack_public_path__ + "static/media/image-placeholder.499c171a.jpg";